import styled from "styled-components"
import CarePackageDetails from "../components/CarePackageDetails"
import CarePackage1 from "../assets/images/care-package-1.jpg"
import CarePackage2 from "../assets/images/care-package-2.jpg"
import CarePackage3 from "../assets/images/care-package-3.jpg"
import { phoneWidth, tabletWidth } from "../Globalstyle"

const StyledCarePackages = styled.div`
  background-color: var(--tan);
`

const StyledInfo = styled.div`
  padding: var(--side-padding);
`

const InfoRow = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: 2fr 3fr;
  align-items: center;
  margin-bottom: 3rem;

  @media (max-width: ${phoneWidth}) {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
`

const Title = styled.div`
  font-size: 3.25rem;
  font-weight: bold;
  width: 100%;
  text-align: left;
`

const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const CarePackageDetailsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: ${tabletWidth}) {
    flex-direction: column;
    gap: 2rem;
  }
`

const ImageContainer = styled.div`
  height: 25rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: ${phoneWidth}) {
    display: flex;
    flex-direction: column;
    height: auto;
  }
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const CarePackages = () => {
  return (
    <StyledCarePackages>
      <StyledInfo>
        <InfoRow>
          <Title>
            Care Packages
          </Title>
          <Description>
            <div>
              Care packages will be distributed among families 
              who have been directly affected by the flood. Each package 
              will several food items and non-food items.
            </div>
            <div>
              Each care package is worth <strong>৳1600</strong>.
            </div>
          </Description>
        </InfoRow>
        <CarePackageDetailsRow>
          <CarePackageDetails
            title="Food Items"
            items={["10kg Rice", "2L Soyabean Oil", "2kg Red Lentil", "1kg Salt", "1kg Chira (Flattened Rice)", "3kg Potato"]}
            wide
          />
          <CarePackageDetails
            title="Non Food Items"
            items={["1pc Lifebuoy Soap", "1pc Wheel Soap"]}
          />
          <CarePackageDetails
            title="Medicine"
            items={["5pcs Orsaline", "10pcs Chlorine Tablet"]}
          />
        </CarePackageDetailsRow>
      </StyledInfo>
      <ImageContainer>
        <Image src={CarePackage1} alt="Care package"/>
        <Image src={CarePackage2} alt="Care package"/>
        <Image src={CarePackage3} alt="Care package"/>
      </ImageContainer>
    </StyledCarePackages>
  )
}

export default CarePackages